import { Route } from "components/utils";
import { Dashboard } from "pages/callCenter/dashboard/Dashboard";
import { NotFound } from "pages/notFound";
import { RouteComponentProps, Switch } from "react-router-dom";

export const CallCenterDashboard = ({ match }: RouteComponentProps): JSX.Element => {
  return (
    <Switch>
      <Route
        component={Dashboard}
        exact={true}
        path={`${match.path}`}
        title="Milo - biuro obsługi klienta"
      />
      <Route component={NotFound} exact={true} path="*" title="Milo" />
    </Switch>
  );
};
